// src/components/tabs/tabs.ts

export function initializeTabs() {
  const savedCarsButton = document.getElementById("tabs-saved-cars");
  const findCarsButton = document.getElementById("tabs-find-cars");
  const savedCarsSection = document.getElementById("garage-section");
  const findCarsSection = document.getElementById("find-cars-section");

  if (!savedCarsButton || !findCarsButton || !savedCarsSection || !findCarsSection) {
    return;
  }

  function setActiveSection(activeButton: HTMLElement, activeSection: HTMLElement) {
    [savedCarsButton, findCarsButton].forEach((btn) => {
      btn?.classList.remove("active");
      btn?.setAttribute("aria-selected", "false");
    });
    [savedCarsSection, findCarsSection].forEach((section) => {
      if (section) {
        (section as HTMLElement).style.display = "none";
      }
    });

    activeButton.classList.add("active");
    activeButton.setAttribute("aria-selected", "true");
    activeSection.style.display = "block";
  }

  savedCarsButton.addEventListener("click", () => {
    setActiveSection(savedCarsButton, savedCarsSection);
  });

  findCarsButton.addEventListener("click", () => {
    setActiveSection(findCarsButton, findCarsSection);
  });
}
